var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bkground fill-height",attrs:{"id":"contenedor-configuracion-main"}},[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }